export type ActivityType = {
    id: string;
    presentationImage?: string;
    technology: Technologies;
    title: string;
    description: string;
    disabled: boolean;
    content: Array<Section>;
};

export type Section = {
    title: string;
    subtitle: string;
    // mainText?: string;
    // mainTextFile?: string;
    paragraphs: Paragraph[];
    images: CaptionedImage[];
    videos: VideoLink[];
    pdfs: string[];
};

export type CaptionedImage = {
    path: string;
    caption?: string;
    position?: HorizontalPosition;
};

export type VideoLink = {
    id: string;
    position: HorizontalPosition;
};

export type Paragraph = {
    text: string;
    image: CaptionedImage;
};

export enum HorizontalPosition {
    undefined = "undefined",
    Left = "left",
    Center = "center",
    Right = "right",
}

export enum Technologies {
    undefined = "undefined",
    Unplugged = "UnPlugged",
    LegoWeDo = "LegoWeDo",
    SAMLabs = "SAMLabs",
    Photon = "Photon",
    MakeyMakey = "MakeyMakey",
    Scratch = "Scratch",
    ScratchJr = "ScratchJr",
}
